import { render, staticRenderFns } from "./TheSideMenuDropzone.vue?vue&type=template&id=28a189ce&scoped=true&"
import script from "./TheSideMenuDropzone.vue?vue&type=script&lang=ts&"
export * from "./TheSideMenuDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./TheSideMenuDropzone.vue?vue&type=style&index=0&id=28a189ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a189ce",
  null
  
)

export default component.exports